var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"title_section"},[_vm._v("Информация об образованных ОНК в субъектах РФ")]),_vm._l((_vm.resArray),function(item,i){return _c('accordion-infomation',{key:i+'accord',attrs:{"content":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }